import { FaxSummaryService } from '@weave/schema-gen-ts/dist/schemas/fax/summary/v1/fax_summary.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaFaxSummaryV1Service = bindHTTP(FaxSummaryService);
